<template>
  <div id="error">

    <section style="padding: 10px;">
      <p>
        {{ $t('message.pagenotfound') }}
        <router-link :to="{ name: 'Home'}">
          {{ $t('message.backtohomepage') }}
        </router-link>
      </p>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: '404Page',
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'error')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/error/404.vue